import Control, { ControlParams } from '../../control/control';
import MenuButton, { MenuButtonParams } from './menuButton';

import { Dictionary } from '../../../utils/types';
import Game from '../../game';


export interface MenuParams extends ControlParams {
  buttonsParameters: Array<MenuButtonParams>;
  x?: number;
  y?: number;
  width?: number;
  itemWidth?: number;
  height?: number;
  ignoreCamera?: boolean;
}

export default class Menu extends Control implements MenuParams {
  static openMenus: Dictionary<Menu> = {};

  buttonsParameters: Array<MenuButtonParams> = [];
  x: number = 0; // left
  y: number = 0; // top
  width!: number;
  itemWidth!: number;
  height!: number;
  ignoreCamera: boolean = false;

  buttons: Array<MenuButton> = [];

  static closeAll(): void {
    Object.values(Menu.openMenus).forEach(menu => menu.close());
  }

  static closeLast(): void {
    Object.values(Menu.openMenus)?.pop()?.close();
  }

  constructor(params: MenuParams) {
    super(params);
    this.applyParams(params);

    if (!this.itemWidth && this.width)
      this.itemWidth = (this.width / this.buttonsParameters.length);
    else if (!this.width && this.itemWidth)
      this.width = this.itemWidth * this.buttonsParameters.length;
    this.createButtons();
    this.create();
  }

  createButtons(): void {
    const { buttonsParameters, ignoreCamera } = this;
    this.buttons = buttonsParameters
      .map((itemParams) => new MenuButton({
        ...itemParams,
        menu: this,
        ignoreCamera,
      } as MenuButtonParams))
      ;
  }

  create(): Menu {
    super.create();
    super.enable();
    Menu.openMenus[this.id] = this;
    return this;
  }

  close(): void {
    super.disable();
    delete Menu.openMenus[this.id];
  }

  draw(): CanvasRenderingContext2D {
    this.buttons.forEach(item => item.draw());
    return this.context;
  }

  onMouseUp = (e: MouseEvent): void => {
    const button = ['left', 'middle', 'right'][e.button];
    switch (button) {
      case 'left': {
        const { x, y } = Game.instance.cursor;
        const itemIndex = this.buttons
          .find(item => item.checkCollisionWithCoords(x, y))
          ?.row
          ;
        if (itemIndex !== undefined)
          this.buttons[itemIndex].select();
        break;
      }
    }
  }

  onMouseMove = (): void => {
    const { x, y } = Game.instance.cursor;
    const itemIndex = this.buttons
      .find(item => item.checkCollisionWithCoords(x, y))
      ?.row
      ;
    this.buttons = this.buttons.map(b => {
      b.hover = false;
      return b;
    });
    if (itemIndex !== undefined)
      this.buttons[itemIndex].hover = true;
  }

  onKeyDown = (e: KeyboardEvent): void => {
    const { code } = e;
    const shortcutCodes = ['KeyZ', 'KeyX', 'KeyC', 'KeyV'];
    const isLastMenu = Object.values(Menu.openMenus).pop()?.id === this.id;
    if (shortcutCodes.includes(code) && isLastMenu) {
      const itemIndex = shortcutCodes.indexOf(code);
      this.buttons[itemIndex].select();
    }
  }
}
